
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { client } from "../../../../tina/__generated__/client";
import { TinaMarkdown } from "tinacms/dist/rich-text";
import { FaCompass } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import PageShell from "../../../components/layout/PageShell";
import PageHeader from "../../../components/layout/PageHeader";
export default function Author({ author }) {
    if (!author) {
        return null;
    }
    const normalizedXHandle = author.xHandle?.replace(/^@/, "");
    return (<PageShell>
      <PageHeader title={author.name} description={author.title} icon={FaCompass}/>
      <section className="max-w-[750px] pb-12">
        {normalizedXHandle && (<a href={`https://x.com/${normalizedXHandle}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-600 transition-colors hover:text-slate-900">
            <FaXTwitter className="h-4 w-4 shrink-0" aria-hidden="true"/>@
            {normalizedXHandle}
          </a>)}
        <div className={`prose prose-slate max-w-none ${normalizedXHandle ? "pt-6" : ""}`}>
          <TinaMarkdown content={author._body}/>
        </div>
      </section>
    </PageShell>);
}
export const getStaticPaths = async () => {
    const authorConnection = await client.queries.authorConnection();
    const authors = authorConnection.data.authorConnection.edges;
    const basePaths = authors.map((author) => {
        return {
            params: {
                filename: author.node._sys.filename,
            },
        };
    });
    const paths = basePaths.map((path) => ({ ...path, locale: "en" }));
    return {
        paths,
        fallback: process.env.CONTENT_SNAPSHOT_BUILD !== "true",
    };
};
const getStaticProps = async ({ params }) => {
    const { filename } = params;
    const variables = {
        relativePath: `${filename}.md`,
    };
    const props = await client.queries.author(variables);
    return {
        props: {
            author: props.data.author,
        },
    };
};

    async function __Next_Translate__getStaticProps__1a0fc0d5a92__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/guides/author/[filename]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0fc0d5a92__ as getStaticProps }
  